{
  "1回の上限": "1回の上限",
  "8文字以上128文字以下で、大文字（A-Z）、小文字（a-z）、数字（0-9）、特殊文字（#?!@$%^&*-）をそれぞれ1文字以上含むよう設定してください。": "8文字以上128文字以下で、大文字（A-Z）、小文字（a-z）、数字（0-9）、特殊文字（#?!@$%^&*-）をそれぞれ1文字以上含むよう設定してください。",
  "Basic(無料)プランではじめる": "Basic(無料)プランではじめる",
  "CSVダウンロード": "CSVダウンロード",
  "Multinational 表示": "Multinational 表示",
  "Plusプランで始める": "Plusプランで始める",
  "Plusプランにアップグレード": "Plusプランにアップグレード",
  "RuleWatcher に 仮登録しました。": "RuleWatcher に 仮登録しました。",
  "RuleWatcherから記事が削除されました": "RuleWatcherから記事が削除されました",
  "RuleWatcherの活用によってどのような環境や社会の問題にアプローチしたいですか？": "RuleWatcherの活用によってどのような環境や社会の問題にアプローチしたいですか？",
  "Study Group Lounge": "Study Group Lounge",
  "agree-privacy-policy": "<l>プライバシーポリシー</l>を読み、同意します。",
  "agree-terms-and-conditions": "<l>利用規約</l>を読み、同意します。",
  "download_item": "{{count, number}}件をダウンロード",
  "download_next_items": "次の{{count, number}}件をダウンロード",
  "privacy-policy-url": "https://rulewatcher.notion.site/privacy-policy-ja",
  "data-policy-url": "https://rulewatcher.notion.site/293e26d944d480779c5fc4deeb3353c5",
  "searchbox_help": {
    "desc_1": "単語の間に半角スペースを挟む",
    "desc_2": "単語の間にOR(大文字)と半角スペース",
    "desc_3": "単語の前にNOT(大文字)と半角スペース",
    "desc_4": "ダブルクォーテーションで囲む",
    "example_1": "AI law",
    "example_2": "international OR multinational",
    "example_3": "NOT regulation",
    "example_4": "\"Artificial intelligence\"",
    "title_1": "すべての単語を含む",
    "title_2": "いずれかの単語を含む",
    "title_3": "単語を含まない",
    "title_4": "複数の単語を1フレーズとして扱う"
  },
  "settings": "設定",
  "規約 / ポリシー": "規約 / ポリシー",
  "terms-and-conditions-url": "https://rulewatcher.notion.site/terms-and-conditions-ja",
  "お手数ですが、しばらくしてから再度お試しください。": "お手数ですが、しばらくしてから再度お試しください。",
  "教育機関向けのお知らせを受け取る": "教育機関向けのお知らせを受け取る",
  "お探しのページが見つかりませんでした。URLが正しいかご確認ください。": "お探しのページが見つかりませんでした。URLが正しいかご確認ください。",
  "お使いのリンクは無効です": "お使いのリンクは無効です",
  "以下のケースに該当している可能性がございます。": "以下のケースに該当している可能性がございます。",
  "お気に入りの記事をブックマークに追加しましょう。": "お気に入りの記事をブックマークに追加しましょう。",
  "お送りした確認メールのリンクから本登録してください。": "メール内のリンクをクリックし、本登録を完了してください。",
  "この画面を閉じると続きからダウンロードできなくなります": "この画面を閉じると続きからダウンロードできなくなります",
  "ご使用端末について": "ご使用端末について",
  "ご入力いただいたメールアドレス宛てに、本人確認メールをお送りいたしました。": "ご入力いただいたメールアドレス宛てに、本人確認メールをお送りいたしました。",
  "ご利用可能なテーマがありません。": "ご利用可能なテーマがありません。",
  "ご紹介者があれば合わせてお名前をお書きください。": "ご紹介者があれば合わせてお名前をお書きください。",
  "しばらくしてもメールが届かない場合は、迷惑メールフォルダをご確認ください。また、登録されていないメールアドレスには送信できません。": "しばらくしてもメールが届かない場合は、迷惑メールフォルダをご確認ください。また、登録されていないメールアドレスには送信できません。",
  "すでにアカウントをお持ちですか？": "すでにアカウントをお持ちですか？",
  "さらに多くの機能を利用できます": "さらに多くの機能を利用できます",
  "どうやってRuleWatcherを知りましたか？": "どうやってRuleWatcherを知りましたか？",
  "データポリシー": "データポリシー",
  "もう一度メールアドレスを入力して、招待メールを受け取ってください。": "もう一度メールアドレスを入力して、招待メールを受け取ってください。",
  "ようこそ RuleWatcher へ!": "ようこそ RuleWatcher へ!",
  "エラーが発生しました": "エラーが発生しました",
  "カテゴリ": "カテゴリ",
  "キャンセル": "キャンセル",
  "キーワードで絞り込み": "キーワードで絞り込み",
  "タイトル": "タイトル",
  "タグ": "タグ",
  "ダウンロードに失敗しました。時間をおいて再度お試しください。": "ダウンロードに失敗しました。時間をおいて再度お試しください。",
  "ダウンロード上限に達しました": "ダウンロード上限に達しました",
  "ダウンロード件数を選択": "ダウンロード件数を選択",
  "ダウンロード言語": "ダウンロード言語",
  "ダウンロード制限": "ダウンロード制限",
  "ダウンロード制限は日本時間の毎月1日にリセットされます": "ダウンロード制限は日本時間の毎月1日にリセットされます",
  "データ更新中は、検索結果と異なる記事がダウンロードされる場合があります": "データ更新中は、検索結果と異なる記事がダウンロードされる場合があります",
  "トップページへ": "トップページへ",
  "パスワード": "パスワード",
  "パスワードが一致しません。": "パスワードが一致しません。",
  "パスワードが設定されました。": "パスワードが設定されました。",
  "パスワードをお忘れですか？": "パスワードをお忘れですか？",
  "パスワードを入力...": "パスワードを入力...",
  "パスワード再設定用のURLが不正です。": "パスワード再設定用のURLが不正です。",
  "パスワード再設定の有効期限が切れたため、このリンクは無効です。以下のボタンをクリックし、画面に表示される指示に従ってパスワード設定してください。": "パスワード再設定の有効期限が切れたため、このリンクは無効です。以下のボタンをクリックし、画面に表示される指示に従ってパスワード設定してください。",
  "パスワードの再設定をやり直す": "パスワードの再設定をやり直す",
  "パスワード設定": "パスワード設定",
  "パスワード設定用のメールを送信しました。": "パスワード設定用のメールを送信しました。",
  "パスワード設定用のメールを送信します。登録されているメールアドレスを入力してください。": "パスワード設定用のメールを送信します。登録されているメールアドレスを入力してください。",
  "パスワード（確認用）": "パスワード（確認用）",
  "フリートライアル期間中に解約することもできます。": "フリートライアル期間中に解約することもできます。",
  "ブックマークはありません": "ブックマークはありません",
  "ブックマークCSVダウンロード": "ブックマークCSVダウンロード",
  "ブックマークした日": "ブックマークした日",
  "ブックマークした日が指定期間に含まれる記事がダウンロードされます": "ブックマークした日が指定期間に含まれる記事がダウンロードされます",
  "ブックマークした日の期間は、ブラウザのタイムゾーン（{{timeZone}}）を基準に判定されます": "ブックマークした日の期間は、ブラウザのタイムゾーン（{{timeZone}}）を基準に判定されます",
  "ブックマーク一覧": "ブックマーク一覧",
  "ブックマーク済み": "ブックマーク済み",
  "ブックマークする": "ブックマークする",
  "対象記事": "対象記事",
  "この期間にブックマークした記事はありません": "この期間にブックマークした記事はありません",
  "今日": "今日",
  "前の月": "前の月",
  "次の月": "次の月",
  "昨日": "昨日",
  "直近7日": "直近7日",
  "直近30日": "直近30日",
  "期間指定": "期間指定",
  "選択した期間の対象記事はすべてCSVに出力しました": "選択した期間の対象記事はすべてCSVに出力しました",
  "プライバシーポリシー": "プライバシーポリシー",
  "プランの選択に失敗しました。何度試しても解決しない場合はサポートに連絡いただけると幸いです。": "プランの選択に失敗しました。何度試しても解決しない場合はサポートに連絡いただけると幸いです。",
  "プラン設定": "プラン設定",
  "プロフィール": "プロフィール",
  "プロフィールの更新に失敗しました。時間をおいて再度お試しください。": "プロフィールの更新に失敗しました。時間をおいて再度お試しください。",
  "プロフィールを更新しました": "プロフィールを更新しました",
  "プロフィール画像": "プロフィール画像",
  "プロフィール画像のアップロードに失敗しました。": "プロフィール画像のアップロードに失敗しました。",
  "カバー画像": "カバー画像",
  "カバー画像のアップロードに失敗しました。": "カバー画像のアップロードに失敗しました。",
  "画像が選択されていません": "画像が選択されていません",
  "画像を変更": "画像を変更",
  "画像を選択": "画像を選択",
  "PNG / JPEG / GIF / WebP に対応しています。": "PNG / JPEG / GIF / WebP に対応しています。",
  "本登録に失敗しました。時間をおいて再度お試しください。": "本登録に失敗しました。時間をおいて再度お試しください。",
  "本登録を開始します": "本登録を開始します",
  "下のボタンを押すと、メールアドレスの確認を完了して本登録手続きに進みます。": "下のボタンを押すと、メールアドレスの確認を完了して本登録手続きに進みます。",
  "本登録を続ける": "本登録を続ける",
  "言語": "言語",
  "言語設定": "言語設定",
  "ページが見つかりません": "ページが見つかりません",
  "メールアドレス": "メールアドレス",
  "メールアドレス変更が完了しました。": "メールアドレス変更が完了しました。",
  "メールアドレス変更の確認に失敗しました。時間をおいて再度お試しください。": "メールアドレス変更の確認に失敗しました。時間をおいて再度お試しください。",
  "メールアドレス変更の申請に失敗しました。時間をおいて再度お試しください。": "メールアドレス変更の申請に失敗しました。時間をおいて再度お試しください。",
  "メールアドレス変更を完了するには、変更前のメールアドレスでログインしてください。": "メールアドレス変更を完了するには、変更前のメールアドレスでログインしてください。",
  "メールアドレス変更を確認します": "メールアドレス変更を確認します",
  "メールアドレスまたはパスワードが正しくありません。": "メールアドレスまたはパスワードが正しくありません。",
  "メールアドレスを入力...": "メールアドレスを入力...",
  "メールアドレス変更を完了する": "メールアドレス変更を完了する",
  "メールアドレスを変更": "メールアドレスを変更",
  "アカウントをお持ちでないですか？": "アカウントをお持ちでないですか？",
  "確認メールを送信": "確認メールを送信",
  "確認メールを送信しました。": "確認メールを送信しました。",
  "現在のパスワード": "現在のパスワード",
  "現在のパスワードが正しくありません。": "現在のパスワードが正しくありません。",
  "新しいメールアドレス": "新しいメールアドレス",
  "新規登録": "新規登録",
  "ログイン": "ログイン",
  "ログインが必要です": "ログインが必要です",
  "ログイン後、新しいメールアドレスに届いた確認リンクをもう一度開いてください。": "ログイン後、新しいメールアドレスに届いた確認リンクをもう一度開いてください。",
  "ログイン後、このメールアドレス変更確認画面に戻ります。": "ログイン後、このメールアドレス変更確認画面に戻ります。",
  "ログイン画面へ": "ログイン画面へ",
  "ログアウト": "ログアウト",
  "ログアウトしてログインし直す": "ログアウトしてログインし直す",
  "上のヒートマップから範囲を選択してください。": "上のヒートマップから範囲を選択してください。",
  "件": "件",
  "件をダウンロード": "件をダウンロード",
  "{{title}}の更新サマリ一覧": "{{title}}の更新サマリ一覧",
  "{{title}} の元記事を開く": "{{title}} の元記事を開く",
  "{{title}} をフィルタ": "{{title}} をフィルタ",
  "更新サマリ": "更新サマリ",
  "更新検知サマリ一覧": "更新検知サマリ一覧",
  "まだ更新検知レポートはありません。": "まだ更新検知レポートはありません。",
  "更新が検知されるとここに表示されます。": "更新が検知されるとここに表示されます。",
  "データの取得に失敗しました。": "データの取得に失敗しました。",
  "サイト名で検索": "サイト名で検索",
  "該当するサイトはありません。": "該当するサイトはありません。",
  "最後に差分を検知した日": "最後に差分を検知した日",
  "最後にサイトを確認した日": "最後にサイトを確認した日",
  "なし": "なし",
  "未実行": "未実行",
  "更新検知対象サイトの取得に失敗しました。": "更新検知対象サイトの取得に失敗しました。",
  "トラッキングサイトは毎朝6時に更新をチェックしています。": "トラッキングサイトは毎朝6時に更新をチェックしています。",
  "フィルタ解除": "フィルタ解除",
  "このサイトでフィルタ": "このサイトでフィルタ",
  "すべて表示": "すべて表示",
  "更新検知ページを表示できませんでした": "更新検知ページを表示できませんでした",
  "購読状況の確認に失敗しました。通信状態をご確認のうえ、再度お試しください。": "購読状況の確認に失敗しました。通信状態をご確認のうえ、再度お試しください。",
  "再試行": "再試行",
  "レポートの取得に失敗しました。": "レポートの取得に失敗しました。",
  "対象サイト": "対象サイト",
  "更新確認日時": "更新確認日時",
  "要約はありません": "要約はありません",
  "※この更新はAIが判定しております。実際の内容は対象サイトをご確認下さい。": "※この更新はAIが判定しております。実際の内容は対象サイトをご確認下さい。",
  "更新後の全文（今回取得）": "更新後の全文（今回取得）",
  "更新前の全文（前回取得）": "更新前の全文（前回取得）",
  "取得全文（従来データ）": "取得全文（従来データ）",
  "...全文を表示": "...全文を表示",
  "Show full text": "全文を表示",
  "本文はありません": "本文はありません",
  "無題の更新レポート": "無題の更新レポート",
  "詳細を見る": "詳細を見る",
  "対象一覧": "対象一覧",
  "会員情報": "会員情報",
  "入力...": "入力...",
  "入力ワード": "入力ワード",
  "全件": "全件",
  "公開日時": "公開日時",
  "filter.label.date": "日付",
  "filter.label.theme": "テーマ",
  "filter.label.regionEconomicUnion": "地域 / 経済連合",
  "filter.label.countryRegionalOrganization": "国 / 地域組織",
  "filter.label.organizationType": "組織タイプ",
  "filter.label.organization": "組織",
  "filter.label.tag": "タグ",
  "filter.label.tags": "タグ",
  "filter.label.publicationStatus": "公開区分",
  "filter.placeholder.organizationType": "組織タイプを検索",
  "filter.placeholder.publicationStatus": "公開区分を検索",
  "filter.placeholder.regionEconomicUnion": "地域 / 経済連合を検索",
  "filter.placeholder.countryRegionalOrganization": "国 / 地域組織を検索",
  "sort.label.organizationName": "組織名で並び替え",
  "sort.label.countryRegionalOrganization": "国 / 地域組織で並び替え",
  "2019年以降の記事のみ収録されています。": "2019年以降の記事のみ収録されています。",
  "分類されたテーマ": "分類されたテーマ",
  "利用規約": "利用規約",
  "割引": "割引",
  "名": "名",
  "国別言及動向": "国別言及動向",
  "国名": "国名",
  "国名: {{country}}": "国名: {{country}}",
  "地球環境": "地球環境",
  "変更": "変更",
  "契約状況": "契約状況",
  "契約中のプラン": "契約中のプラン",
  "システム管理者": "システム管理者",
  "システム管理者としてログインしています": "システム管理者としてログインしています",
  "姓": "姓",
  "年払い": "年払い",
  "年払いで{{percentage}}%お得": "年払いで{{percentage}}%お得",
  "戻る": "戻る",
  "技術と社会": "技術と社会",
  "仮登録メールを受け取る": "仮登録メールを受け取る",
  "政府やNGO/シンクタンク/国際機関の発信情報を一元化 - 様々な分析画面で新たな発見を": "政府やNGO/シンクタンク/国際機関の発信情報を一元化 - 様々な分析画面で新たな発見を",
  "文字を入力して絞り込んでください。": "文字を入力して絞り込んでください。",
  "新しいパスワードを入力...": "新しいパスワードを入力...",
  "新しいパスワードを再入力...": "新しいパスワードを再入力...",
  "新しい経済": "新しい経済",
  "暮らしと権利": "暮らしと権利",
  "最新の記事から選択した件数ダウンロードされます": "最新の記事から選択した件数ダウンロードされます",
  "月": "月",
  "月払い": "月払い",
  "月間ダウンロード": "月間ダウンロード",
  "月額{{percentage}}%お得": "月額{{percentage}}%お得",
  "期間": "期間",
  "期間: {{start}} ~ {{end}}": "期間: {{start}} ~ {{end}}",
  "条件に合致するデータがありませんでした、条件を変更して再度検索してください。": "条件に合致するデータがありませんでした、条件を変更して再度検索してください。",
  "検索": "検索",
  "analyze.search.freewordPlaceholder": "日本語検索ではタイトルと要約が、英語検索ではタイトル・要約・本文が検索対象になります",
  "analyze.search.scope.japanese": "「{{keyword}}」をタイトル・要約から検索した結果です",
  "analyze.search.scope.english": "「{{keyword}}」をタイトル・要約・本文から検索した結果です",
  "analyze.search.scope.both": "「{{keyword}}」をタイトル・要約（英数字は本文も含む）から検索した結果です",
  "検索のヒント": "検索のヒント",
  "検索ワード": "検索ワード",
  "検索ワードは{{maxSearchKeywordLength}}文字以内で入力してください。": "検索ワードは{{maxSearchKeywordLength}}文字以内で入力してください。",
  "検索ワード英語翻訳": "検索ワード英語翻訳",
  "記事検索": "記事検索",
  "検索条件に一致する記事がダウンロードされます": "検索条件に一致する記事がダウンロードされます",
  "検索結果": "検索結果",
  "次の": "次の",
  "削除済みの記事はCSVに含まれません": "削除済みの記事はCSVに含まれません",
  "氏名（名）を入力...": "氏名（名）を入力...",
  "氏名（姓）を入力...": "氏名（姓）を入力...",
  "現在、このアプリケーションはパソコンおよびタブレットでのご利用を推奨しております。": "現在、このアプリケーションはパソコンおよびタブレットでのご利用を推奨しております。",
  "現在お住まいの国・地域": "現在お住まいの国・地域",
  "画面サイズの小さいデバイスでは、表示が意図通りに行われない可能性がありますので、できるだけ大きめの画面のデバイスをご使用ください。何卒ご理解のほど、よろしくお願い申し上げます。": "画面サイズの小さいデバイスでは、表示が意図通りに行われない可能性がありますので、できるだけ大きめの画面のデバイスをご使用ください。何卒ご理解のほど、よろしくお願い申し上げます。",
  "※第三者によるなりすましを防ぐなどセキュリティ上の理由から、有効なリンクの数・期限・使用回数を限定しております。": "※第三者によるなりすましを防ぐなどセキュリティ上の理由から、有効なリンクの数・期限・使用回数を限定しております。",
  "登録できないメールアドレスです。すでにご登録済みの方は、ログインをお試しください。": "登録できないメールアドレスです。すでにご登録済みの方は、ログインをお試しください。",
  "登録期限が切れてしまいました。": "登録期限が切れてしまいました。",
  "登録期限切れ": "登録期限切れ",
  "本登録ページ": "本登録ページ",
  "まだ本登録は完了していません": "まだ本登録は完了していません",
  "確認メールの有効期限が切れています。下記から、再度メールアドレスをご登録ください。": "確認メールの有効期限が切れています。下記から、再度メールアドレスをご登録ください。",
  "仮登録メールの有効期限が切れています。下記から仮登録メールを再発行してください。": "仮登録メールの有効期限が切れています。下記から仮登録メールを再発行してください。",
  "仮登録メールを再発行する": "仮登録メールを再発行する",
  "本登録ページ（まだ本登録は完了していません）": "本登録ページ（まだ本登録は完了していません）",
  "この確認リンクはすでに使用されています。下記から仮登録メールを再発行してください。": "この確認リンクはすでに使用されています。下記から仮登録メールを再発行してください。",
  "よくあるケース：": "よくあるケース：",
  "同じメールアドレスで2回以上仮登録手続きが行われた": "同じメールアドレスで2回以上仮登録手続きが行われた",
  "最新の仮登録メールに記載されているリンクをお使いください。": "最新の仮登録メールに記載されているリンクをお使いください。",
  "URLの文字列が途切れている/不要な文字列を含んでいる/メールの自動翻訳機能によりリンクが変更されてしまった": "URLの文字列が途切れている/不要な文字列を含んでいる/メールの自動翻訳機能によりリンクが変更されてしまった",
  "再度正しいリンクをご利用ください。": "再度正しいリンクをご利用ください。",
  "→": "→",
  "管理画面へ": "管理画面へ",
  "キーワードでタグを検索...": "キーワードでタグを検索...",
  "{{articleCount}}件の記事": "{{articleCount}}件の記事",
  "約 {{articleCount}} 件": "約 {{articleCount}} 件の結果",
  "並び順": "並び順",
  "新しい順": "新しい順",
  "関連度順": "関連度順",
  "約 {{articleCount}} 件の結果 [{{start}}〜{{end}}件を表示中]": "約{{articleCount}}件の結果 [{{start}}〜{{end}}を表示中]",
  "ページの先頭に戻る": "ページの先頭に戻る",
  "前のページ": "前のページ",
  "次のページ": "次のページ",
  "ページ指定": "ページ指定",
  "ページ番号を入力": "ページ番号を入力",
  "組織タイプ": "組織タイプ",
  "組織": "組織",
  "組織名": "組織名",
  "翻訳中にエラーが発生しました": "翻訳中にエラーが発生しました",
  "表示件数": "表示件数",
  "表示間隔": "表示間隔",
  "テーマ・タグ": "テーマ・タグ",
  "要約": "要約",
  "article.label.theme": "#THEME",
  "article.label.tags": "TAGS",
  "言及された人物": "言及された人物",
  "言及された地名": "言及された地名",
  "言及された組織": "言及された組織",
  "キャンペーン特典適用中": "キャンペーン特典適用中",
  "割引が適用されています": "割引が適用されています",
  "無料トライアル{{days}}日が適用されています": "無料トライアル{{days}}日が適用されています",
  "割引と無料トライアル{{days}}日が適用されています": "割引と無料トライアル{{days}}日が適用されています",
  "トライアル中は支払い方法の入力が不要です": "トライアル中は支払い方法の入力が不要です",
  "記事数": "記事数",
  "読み込み中...": "読み込み中...",
  "調査・検索したい分野を選択してください": "調査・検索したい分野を選択してください",
  "請求情報の管理": "請求情報の管理",
  "追加の社会課題テーマと、より高度な分析機能をご利用いただけます。": "追加の社会課題テーマと、より高度な分析機能をご利用いただけます。",
  "さらなる可能性を解放しましょう。": "さらなる可能性を解放しましょう。",
  "以下の RuleWatcher Plus 機能でリサーチを強化しましょう。": "以下の RuleWatcher Plus 機能でリサーチを強化しましょう。",
  "RuleWatcher Plus の機能紹介": "RuleWatcher Plus の機能紹介",
  "RuleWatcher biz. の機能紹介": "RuleWatcher biz. の機能紹介",
  "RuleWatcher biz. の機能一覧": "RuleWatcher biz. の機能一覧",
  "RuleWatcher biz. の機能で、組織のリサーチをさらに強化しましょう。": "RuleWatcher biz. の機能で、組織のリサーチをさらに強化しましょう。",
  "biz. 限定テーマ4種": "biz. 限定テーマ4種",
  "組織向けの4つの限定テーマで、さらに専門的な領域まで調査範囲を広げられます。": "組織向けの4つの限定テーマで、さらに専門的な領域まで調査範囲を広げられます。",
  "カスタムタグ作成": "カスタムタグ作成",
  "組織の調査課題に合わせて、独自のタグの作成依頼が行えます": "組織の調査課題に合わせて、独自のタグの作成依頼が行えます",
  "情報ソース追加リクエスト": "情報ソース追加リクエスト",
  "調査対象に加えたい媒体や情報ソースの追加をリクエストできます。": "調査対象に加えたい媒体や情報ソースの追加をリクエストできます。",
  "CSVダウンロード 10,000件": "CSVダウンロード 10,000件",
  "検索結果から毎月最大10,000件の記事をCSVで書き出せます。": "検索結果から毎月最大10,000件の記事をCSVで書き出せます。",
  "クレジットカード・請求書払い": "クレジットカード・請求書払い",
  "クレジットカードまたは請求書から、組織に合った支払い方法を選べます。": "クレジットカードまたは請求書から、組織に合った支払い方法を選べます。",
  "保存フィルター": "保存フィルター",
  "アラート": "アラート",
  "検索結果をCSVで書き出し、詳しい分析やレポート作成、共有に活用できます。Plusでは毎月最大3,000件の記事をダウンロードできます。": "検索結果をCSVで書き出し、詳しい分析やレポート作成、共有に活用できます。Plusでは毎月最大3,000件の記事をダウンロードできます。",
  "検索結果を形づくるトピックをひと目で把握できます。記事のまとまりを大きさと色で探索し、主要なテーマや新たな傾向を発見できます。": "検索結果を形づくるトピックをひと目で把握できます。記事のまとまりを大きさと色で探索し、主要なテーマや新たな傾向を発見できます。",
  "注目度の変化を時系列で追跡できます。期間ごとのトピックを比較し、上昇中・減少中・継続中の傾向を把握できます。": "注目度の変化を時系列で追跡できます。期間ごとのトピックを比較し、上昇中・減少中・継続中の傾向を把握できます。",
  "よく使う検索条件を保存し、すべての設定を保ったままワンクリックで呼び出せます。": "よく使う検索条件を保存し、すべての設定を保ったままワンクリックで呼び出せます。",
  "保存したフィルターをメールアラートに設定し、調査条件に合う新着記事をすぐに確認できます。": "保存したフィルターをメールアラートに設定し、調査条件に合う新着記事をすぐに確認できます。",
  "厳選された5つの追加テーマを利用して調査範囲を広げ、より多くの政策分野を横断するつながりを発見できます。": "厳選された5つの追加テーマを利用して調査範囲を広げ、より多くの政策分野を横断するつながりを発見できます。",
  "前のPlus機能を表示": "前のPlus機能を表示",
  "次のPlus機能を表示": "次のPlus機能を表示",
  "{{feature}}の紹介画像": "{{feature}}の紹介画像",
  "{{feature}}の画像を追加予定": "{{feature}}の画像を追加予定",
  "{{feature}}を表示": "{{feature}}を表示",
  "無料トライアルあり": "無料トライアルあり",
  "ウェブサイトで詳細を見る": "ウェブサイトで詳細を見る",
  "案内を閉じる": "閉じる",
  "7日間の無料トライアルを始める": "7日間の無料トライアルを始める",
  "閉じる": "閉じる",
  "高度な分析ツール": "高度な分析ツール",
  "TreeMap と Transition で検索結果の傾向を立体的に把握できます。": "TreeMap と Transition で検索結果の傾向を立体的に把握できます。",
  "フィルター保存": "フィルター保存",
  "よく使う条件を保存し、ワンクリックで呼び出せます。": "よく使う条件を保存し、ワンクリックで呼び出せます。",
  "5つのテーマ追加": "5つのテーマ追加",
  "学びを広げられます。": "学びを広げられます。",
  "CSV ダウンロード 3000件/月": "CSV ダウンロード 3000件/月",
  "月 3,000 件までエクスポートできます。": "月 3,000 件までエクスポートできます。",
  "アラート通知": "アラート通知",
  "フィルター条件に合う新着記事を通知で受け取れます。": "フィルター条件に合う新着記事を通知で受け取れます。",
  "RuleWatcher Plus の機能でリサーチをさらに強化できます。": "RuleWatcher Plus の機能でリサーチをさらに強化できます。",
  "{{days}}日間無料で試す": "{{days}}日間無料で試す",
  "無料で試す": "無料で試す",
  "7日間の無料トライアルを開始": "7日間の無料トライアルを開始",
  "7日間無料で試す": "7日間無料で試す",
  "トライアル期間中はダウンロード上限100件です。": "※トライアル期間中はダウンロード上限100件です。",
  "日本語": "日本語",
  "英語": "英語",
  "ブロック: {{label}}": "ブロック: {{label}}",
  "ダブルクリックでブロックを選択します。": "ダブルクリックでブロックを選択します。",
  "全体表示に戻るには、ESCキー押下または右ダブルクリックしてください。": "全体表示に戻るには、ESCキー押下または右ダブルクリックしてください。",
  "TreeMapの操作ヒントを閉じる": "TreeMapの操作ヒントを閉じる",
  "TreeMapの操作ヒントを表示する": "TreeMapの操作ヒントを表示する",
  "RuleWatcherに登録すると、記事の調査・参照を継続しやすくなります。": "RuleWatcherに登録すると、記事の調査・参照を継続しやすくなります。",
  "続けて記事を便利に活用するには、アカウント登録をおすすめします。": "続けて記事を便利に活用するには、アカウント登録をおすすめします。",
  "QRコードを開く": "QRコードを開く",
  "記事を共有": "記事を共有",
  "その他のオプション": "その他のオプション",
  "記事リンクをコピー": "記事リンクをコピー",
  "記事のリンクをコピーしました": "記事のリンクをコピーしました",
  "コピーしました": "コピーしました",
  "原文サイトを開く": "原文サイトを開く",
  "記事詳細を開く": "記事詳細を開く",
  "共有": "共有",
  "QRコード": "QRコード",
  "QRコードで共有": "QRコードで共有",
  "記事URL": "記事URL",
  "読み込み中": "読み込み中",
  "QRコードを閉じる": "QRコードを閉じる",
  "記事詳細のQRコード": "記事詳細のQRコード",
  "QRコードを生成できませんでした": "QRコードを生成できませんでした",
  "記事が見つかりませんでした。": "記事が見つかりませんでした。",
  "ログインする": "ログインする",
  "TreeMap と Transition で検索結果の傾向を直感的に把握できます。": "TreeMap と Transition で検索結果の傾向を直感的に把握できます。",
  "テーマの幅を広げて学びを深められます。": "テーマの幅を広げて学びを深められます。",
  "月 3,000 件まで記事をエクスポートできます。": "月 3,000 件まで記事をエクスポートできます。",
  "条件に合う新着記事をメールでお知らせします。": "条件に合う新着記事をメールでお知らせします。",
  "送信": "送信",
  "選択いただいたテーマが存在しないか、ご利用できないテーマです。": "選択いただいたテーマが存在しないか、ご利用できないテーマです。",
  "選択中の範囲の記事": "選択中の範囲の記事",
  "選択肢数が表示上限を超えています。": "選択肢数が表示上限を超えています。",
  "７日フリートライアルで開始できます。": "７日フリートライアルで開始できます。",
  "deleted-article-link-text": "原文のリンクは <l>こちら</l> です。",
  "テーマ横断検索": "テーマ横断検索",
  "テーマで検索": "テーマで検索",
  "世界の政策変化を一次情報から追跡": "世界の政策変化を一次情報から追跡",
  "150以上の国の政府・国際機関から最新の政策情報を収集します。": "150以上の国の政府・国際機関から最新の政策情報を収集します。",
  "政策情報を検索": "政策情報を検索",
  "テーマから検索": "テーマから検索",
  "SDGsから検索": "SDGsから検索",
  "sdg.goal.1": "SDG 1: 貧困をなくそう",
  "sdg.goal.2": "SDG 2: 飢餓をゼロに",
  "sdg.goal.3": "SDG 3: すべての人に健康と福祉を",
  "sdg.goal.4": "SDG 4: 質の高い教育をみんなに",
  "sdg.goal.5": "SDG 5: ジェンダー平等を実現しよう",
  "sdg.goal.6": "SDG 6: 安全な水とトイレを世界中に",
  "sdg.goal.7": "SDG 7: エネルギーをみんなに そしてクリーンに",
  "sdg.goal.8": "SDG 8: 働きがいも経済成長も",
  "sdg.goal.9": "SDG 9: 産業と技術革新の基盤をつくろう",
  "sdg.goal.10": "SDG 10: 人や国の不平等をなくそう",
  "sdg.goal.11": "SDG 11: 住み続けられるまちづくりを",
  "sdg.goal.12": "SDG 12: つくる責任 つかう責任",
  "sdg.goal.13": "SDG 13: 気候変動に具体的な対策を",
  "sdg.goal.14": "SDG 14: 海の豊かさを守ろう",
  "sdg.goal.15": "SDG 15: 陸の豊かさも守ろう",
  "sdg.goal.16": "SDG 16: 平和と公正をすべての人に",
  "sdg.goal.17": "SDG 17: パートナーシップで目標を達成しよう",
  "絞り込まずに検索": "絞り込まずに検索",
  "キーワードの関係からたどる": "キーワードの関係からたどる",
  "課題は相互につながっています。ひとつを解くと、別の課題も動きます。そのつながりを見つけましょう。": "課題は相互につながっています。ひとつを解くと、別の課題も動きます。そのつながりを見つけましょう。",
  "TagViewを開く": "TagViewを開く",
  "人獣共通感染症": "人獣共通感染症",
  "気候変動適応": "気候変動適応",
  "グローバルヘルス": "グローバルヘルス",
  "淡水資源": "淡水資源",
  "フードシステム": "フードシステム",
  "home.category.globalEnvironment": "地球環境",
  "home.category.techAndSociety": "技術と社会",
  "home.category.humanRights": "人権",
  "home.category.newEconomy": "新しい経済",
  "すべてのテーマ": "すべてのテーマ",
  "テーマ": "テーマ",
  "テーマ：": "テーマ：",
  "全部見る...": "全部見る...",
  "総数": "総数",
  "キーワードを検索（部分一致）": "キーワードを検索（部分一致）",
  "タグ検索": "タグ検索",
  "ズームイン": "ズームイン",
  "ズームアウト": "ズームアウト",
  "リセット": "リセット",
  "選択テーマへズーム": "選択テーマへズーム",
  "テーマへ移動...": "テーマへ移動",
  "テーマ解除": "テーマ解除",
  "テーマ移動を解除": "テーマ移動を解除",
  "社会課題": "社会課題",
  "はい": "はい",
  "いいえ": "いいえ",
  "未設定": "未設定",
  "フィルタタグ詳細情報": "フィルタタグ詳細情報",
  "タグ: AND": "タグ: AND",
  "タグ: OR": "タグ: OR",
  "タグ: NOT": "タグ: NOT",
  "表示設定": "表示設定",
  "タグ表示設定": "タグ表示設定",
  "タグ：": "タグ：",
  "Show More": "すべて表示",
  "Show Less": "閉じる",
  "閉じる ▲": "閉じる ▲",
  "開く ▼": "開く ▼",
  "タグを探索": "TagViewでタグを探索",
  "TagViewのイメージ": "TagViewのイメージ",
  "フィルタ条件にヒットする記事件数： {{articleCount}} ": "フィルタ条件にヒットする記事件数： {{articleCount}} ",
  "アシストタグ": "アシストタグ",
  "クロスイシュータグ": "クロスイシュータグ",
  "クロスタグ": "クロスタグ",
  "イシュータグ": "イシュータグ",
  "ノーマルタグ": "ノーマルタグ",
  "テーマタグ": "テーマタグ",
  "アシストタグの説明": "全テーマに付随する一般タグ（税・パブリックコメントなど）",
  "クロスイシュータグの説明": "複数テーマにまたがる社会課題を指すタグ",
  "クロスタグの説明": "複数テーマにまたがる一般タグ",
  "イシュータグの説明": "社会課題を指すタグ",
  "ノーマルタグの説明": "いずれかのテーマに付随する一般タグ",
  "表示": "表示",
  "非表示": "非表示",
  "上に移動": "上に移動",
  "下に移動": "下に移動",
  "左に移動": "左に移動",
  "右に移動": "右に移動",
  "このフィルタ条件で記事を見る": "このフィルタ条件で記事を見る",
  "この条件で記事を見る": "この条件で記事を見る",
  "該当するタグが見つかりません": "該当するタグが見つかりません",
  "フィルターで選択中": "フィルターで選択中",
  "Assist Tags": "アシストタグ",
  "Cross-Issue Tags": "クロスイシュータグ",
  "Cross Tags": "クロスタグ",
  "Issue Tags": "イシュータグ",
  "Issue Tag": "イシュータグ",
  "Normal Tags": "ノーマルタグ",
  "Normal Tag": "ノーマルタグ",
  "Theme": "テーマ",
  "関連テーマ": "関連テーマ",
  "記事": "記事",
  "説明未設定": "説明未設定",
  "フィルター(AND)に追加": "フィルター(AND)に追加",
  "フィルター(OR)に追加": "フィルター(OR)に追加",
  "フィルター(NOT)に追加": "フィルター(NOT)に追加",
  "RuleWatcherタグを探索し、選択する": "RuleWatcherタグを探索し、選択する",
  "適用": "適用",
  "もどる": "もどる",
  "選択解除": "選択解除",
  "もしかして・・・": "タグ候補",
  "検索候補": "検索候補",
  "クリア": "クリア",
  "検索結果をクリア": "検索結果をクリア",
  "このテーマの記事を閲覧するには有料契約が必要です。": "このテーマの記事を閲覧するには有料契約が必要です。",
  "ノードタイプ表示設定": "ノードタイプ表示設定",
  "ネットワークに表示するノードを選択": "ネットワークに表示するノードを選択",
  "networkHelp.title": "操作ガイド",
  "networkHelp.openLabel": "操作ヘルプ",
  "networkHelp.close": "閉じる",
  "networkHelp.hideForever": "今後表示しない",
  "networkHelp.pressKeyToToggle": "キー",
  "networkHelp.toToggle": "で開閉",
  "networkHelp.pan.title": "パン",
  "networkHelp.pan.desc": "ドラッグまたはマウスホイールでキャンバスを移動",
  "networkHelp.zoom.title": "ズーム",
  "networkHelp.zoom.desc": "Ctrl + ホイール、または右のスライダーで拡大縮小",
  "networkHelp.node.title": "タグ操作",
  "networkHelp.node.desc": "クリックで詳細表示、関連テーマへの線を表示",
  "networkHelp.filter.title": "表示設定",
  "networkHelp.filter.desc": "タグ種別の表示/非表示を切り替え",
  "含める": "含める",
  "含めない": "含めない",
  "パン": "パン",
  "ドラッグまたはマウスホイールでキャンバスを移動します。ホイール上下、Shift＋ホイール左右": "ドラッグまたはマウスホイールでキャンバスを移動します。ホイール上下、Shift＋ホイール左右",
  "ズーム": "ズーム",
  "ピンチまたは Ctrl + マウスホイール、 右のスライダー +/- ボタンで拡大縮小できます。": "ピンチまたは Ctrl + マウスホイール、 右のスライダー +/- ボタンで拡大縮小できます。",
  "タグ(ノード)操作": "タグ(ノード)操作",
  "タグ(ノード)をクリックして詳細を表示。関連テーマへ線(エッジ)を表示します。": "タグ(ノード)をクリックして詳細を表示。関連テーマへ線(エッジ)を表示します。",
  "タグ種別の表示/非表示切り替えを行えます。": "タグ種別の表示/非表示切り替えを行えます。",
  "タグ種類の説明": "タグ種類の説明",
  "Content": "内容",
  "Filter": "フィルタ",
  "Source": "発信元",
  "Bookmarks": "ブックマーク",
  "All Sources": "情報源一覧",
  "Web Tracker": "Web Tracker",
  "CSV Download": "CSVダウンロード",
  "Goal {{goal}}": "目標 {{goal}}",
  "Navigate using the relations of keywords": "キーワードの関連性を使って検索する",
  "Open TagView": "TagViewを開く",
  "Saved filters": "保存済みフィルタ",
  "SDGs": "SDGs",
  "Coming Soon": "近日公開",
  "ノーマルタグを表示": "ノーマルタグを表示",
  "保存されたフィルター": "保存されたフィルター",
  "保存されたフィルタ": "保存されたフィルタ",
  "保存済み": "保存済み",
  "フィルターの適用": "フィルターの適用",
  "フィルターを保存": "フィルターを保存",
  "保存可能なフィルター数が上限に達しています。既存のフィルターを上書きするか、不要なフィルターを削除してから新規作成してください。": "保存可能なフィルター数が上限に達しています。既存のフィルターを上書きするか、不要なフィルターを削除してから新規作成してください。",
  "新規作成": "新規作成",
  "上書き": "上書き",
  "上書きするフィルタを選択": "上書きするフィルタを選択",
  "上書き保存": "上書き保存",
  "フィルタ名": "フィルタ名",
  "フィルタ名を入力してください": "フィルタ名を入力してください",
  "通知を受け取る": "通知を受け取る",
  "日本時間午前8時に条件に一致する新着記事があれば通知されます。": "日本時間午前8時に条件に一致する新着記事があれば通知されます。",
  "※通知できるフィルタ条件は1つまでです。他のフィルターに通知設定されている場合は他のフィルターはOFFになります。": "※通知できるフィルタ条件は1つまでです。他のフィルターに通知設定されている場合は他のフィルターはOFFになります。",
  "重要なお知らせ": "重要なお知らせ",
  "通知設定は1つの検索条件に対してのみ有効です。他の検索条件で通知設定をオンにしている場合、それらの設定は自動的にオフになります。": "通知設定は1つの検索条件に対してのみ有効です。他の検索条件で通知設定をオンにしている場合、それらの設定は自動的にオフになります。",
  "通知機能について": "通知機能について",
  "通知タイミング": "通知タイミング",
  "毎朝8時以降、新しい記事が追加されたタイミングで通知します（1日最大1回）": "毎朝8時以降、新しい記事が追加されたタイミングで通知します（1日最大1回）",
  "通知対象の記事": "通知対象の記事",
  "以下の条件全てを満たす記事が対象です": "以下の条件全てを満たす記事が対象です",
  "過去3日以内に検索可能になった記事": "過去3日以内に検索可能になった記事",
  "前回通知時以降に新しく追加された記事": "前回通知時以降に新しく追加された記事",
  "ご注意": "ご注意",
  "グローバルな記事収集を行っているため、時差の影響により記事の公開から通知まで時間差が発生する場合がございます。": "グローバルな記事収集を行っているため、時差の影響により記事の公開から通知まで時間差が発生する場合がございます。",
  "保存": "保存",
  "設定を保存しました": "設定を保存しました",
  "変更はまだ保存されていません": "変更はまだ保存されていません",
  "フィルターの保存に失敗しました": "フィルターの保存に失敗しました",
  "保存されたフィルタの読み込みに失敗しました": "保存されたフィルタの読み込みに失敗しました",
  "保存されたフィルタはありません": "保存されたフィルタはありません",
  "保存可能なフィルタ数の上限に達しています。上書き機能をご利用ください。": "保存可能なフィルタ数の上限に達しています。上書き機能をご利用ください。",
  "保存されたフィルタがありません。新規作成をご利用ください。": "保存されたフィルタがありません。新規作成をご利用ください。",
  "既に検索条件が設定されています。保存されたフィルター「{{filterName}}」を適用しますか？": "既に検索条件が設定されています。保存されたフィルター「{{filterName}}」を適用しますか？",
  "適用する": "適用する",
  "反映": "反映",
  "編集": "編集",
  "削除": "削除",
  "フィルタ名の編集": "フィルタ名の編集",
  "更新": "更新",
  "更新中...": "更新中...",
  "削除中...": "削除中...",
  "フィルタの削除": "フィルタの削除",
  "この操作は取り消すことができません。": "この操作は取り消すことができません。",
  "「{{filterName}}」を削除しますか？": "「{{filterName}}」を削除しますか？",
  "アクセス権限がありません": "アクセス権限がありません",
  "トップに戻る": "トップに戻る",
  "通知について": "通知について",
  "{{date}}実行の「{{filterName}}」の新着記事": "{{date}}実行の「{{filterName}}」の新着記事",
  "組織一覧": "組織一覧",
  "情報源一覧": "情報源一覧",
  "{{value}}件": "{{value}}件",
  "フィルター": "フィルター",
  "適用中": "適用中",
  "フリーテキスト検索": "フリーテキスト検索",
  "キーワードを入力": "キーワードを入力",
  "条件をクリア": "条件をクリア",
  "この条件で検索": "この条件で検索",
  "組織の取得に失敗しました。時間をおいてから再度お試しください。": "組織の取得に失敗しました。時間をおいてから再度お試しください。",
  "該当する組織がありません。": "該当する組織がありません。",
  "{{current}}/{{last}}ページ": "{{current}}/{{last}}ページ",
  "最新記事日": "最新記事日",
  "最古記事日": "最古記事日",
  "キーワードで検索": "キーワードで検索",
  "選択したフィルターは即時に適用されます。": "選択したフィルターは即時に適用されます。",
  "このメールアドレスはすでに使用されています": "このメールアドレスはすでに使用されています",
  "確認しようとしたメールアドレスは、すでに別のアカウントで使用されています。": "確認しようとしたメールアドレスは、すでに別のアカウントで使用されています。",
  "プロフィール画面から別のメールアドレスで変更を再申請してください。": "プロフィール画面から別のメールアドレスで変更を再申請してください。",
  "プロフィールに戻る": "プロフィールに戻る",
  "選択": "選択",
  "候補がありません": "候補がありません",
  "候補の取得に失敗しました。再試行してください。": "候補の取得に失敗しました。再試行してください。",
  "候補の一部情報を取得できませんでした。": "候補の一部情報を取得できませんでした。",
  "入力を続けて候補を絞り込んでください。": "入力を続けて候補を絞り込んでください。",
  "適用したフィルタ": "適用したフィルタ",
  "タグの候補": "タグの候補",
  "候補をすべて非表示": "候補を非表示",
  "{{tag}}をフィルタから外す": "{{tag}}をフィルタから外す",
  "{{tag}}を候補から外す": "{{tag}}を候補から外す",
  "検索結果に該当なし": "検索結果に該当なし",
  "home.continueWithoutFilter": "絞り込まずに続ける",
  "home.sdg.search": "SDG から検索",
  "home.sdg.searchFrom": "から検索",
  "auth.login.welcomeBack": "おかえりなさい",
  "auth.login.description": "政府、国際機関、NGOが発信する世界最大級の一次情報データセットを、毎日更新でお届けします。",
  "auth.login.submit": "ログイン"
}
